import { Box } from '@mui/material'
import React from 'react'

interface Props {
  columns?: string[]
  rows?: string[]
  gap?: number
  rowGap?: number
  columnGap?: number
  justifyItems?: 'start' | 'end' | 'center' | 'stretch'
  alignItems?: 'start' | 'end' | 'center' | 'stretch'
  justifyContent?: 'start' | 'end' | 'center' | 'stretch' | 'space-around' | 'space-between' | 'space-evenly'
  alignContent?: 'start' | 'end' | 'center' | 'stretch' | 'space-around' | 'space-between' | 'space-evenly'
  children: React.ReactNode
}

export default function Grid(props: Props) {
  const { columns, rows, gap, rowGap, columnGap, justifyItems, alignItems, justifyContent, alignContent, children } =
    props
  const gridStyles = {
    display: 'grid',
    ...(columns && {
      gridTemplateColumns: columns.join(' '),
    }),
    ...(rows && {
      gridTemplateRows: rows.join(' '),
    }),
    ...(gap !== undefined && { gap }),
    ...(rowGap !== undefined && { rowGap }),
    ...(columnGap !== undefined && { columnGap }),
    ...(justifyItems && { justifyItems }),
    ...(alignItems && { alignItems }),
    ...(justifyContent && { justifyContent }),
    ...(alignContent && { alignContent }),
  }

  return <Box sx={{ ...gridStyles }}>{children}</Box>
}
